import React from 'react';
import PropTypes from 'prop-types';

const NoResults = props => (
	<div className="re-container re-container-outer re-noresults-container">
		<img className="re-noresults-img" src={props.src} />
		<p className="re-noresults-header">{props.message}</p>
		{props.href && props.hrefText && <a href={props.href} onClick={props.callBack} data-testid="noresultlink">{props.hrefText}</a>}
	</div>
);

NoResults.propTypes = {
	message: PropTypes.string.isRequired,
	href: PropTypes.string,
	hrefText: PropTypes.string,
	src: PropTypes.string,
	callBack: PropTypes.func
};

NoResults.defaultProps = {
	src: '/assets/common/images/cactus.png'
};

export default NoResults;
